import script from "./cargotarProdguid.vue?vue&type=script&setup=true&lang=js"
export * from "./cargotarProdguid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__